import {forwardRef} from 'react';
import cx from 'classnames';

import {RadialProgress, Text} from '#component/base';
import {CheckInCarousel} from '#component/partial';
import {CarouselProvider} from '#component/provider';
import {sprinkles} from '#style/sprinkles';

import {CheckInStatsProps} from './CheckInStats.types';

import * as css from './CheckInStats.css';

/**
 * This component renders the "stats" portion of the Check In page's
 * result screen's footer.
 */
export const CheckInStats = forwardRef<HTMLDivElement, CheckInStatsProps>(
  ({className, checkIns = [], ...otherProps}, ref) => {
    const completedCheckInsCount = checkIns?.filter(({completed}) => !!completed).length || 0;
    const totalCheckInsCount = checkIns?.length || 0;
    const totalCheckInsCountPercentage =
      Math.round((completedCheckInsCount / totalCheckInsCount) * 100) || 0;

    return (
      <div
        className={cx(sprinkles({flex: 'flex', dir: 'col', gap: 32}), className)}
        ref={ref}
        {...otherProps}>
        <div
          className={sprinkles({
            dir: ['row', 'colReverse'],
            flex: 'flex',
            gap: 20,
            items: 'center',
            pX: 24,
          })}>
          <Text color="deepBurgundy" fontWeight="semiBold" variant="bodyLarge">
            {`You’ve checked-in ${totalCheckInsCountPercentage}% of the time`}
          </Text>
          <RadialProgress
            className={css.progress}
            label={
              <Text color="inherit" variant="heading2">
                {completedCheckInsCount}
                <Text color="inherit" variant="bodyLarge">
                  {`/${totalCheckInsCount}`}
                </Text>
              </Text>
            }
            value={completedCheckInsCount}
            maxValue={totalCheckInsCount}
          />
        </div>

        <CarouselProvider>
          <CheckInCarousel checkIns={checkIns} />
        </CarouselProvider>
      </div>
    );
  },
);
